import React from 'react';
import { Button } from '@mui/material';

import { ReadFile, useHiddenFileSelect } from '@paragon/client-tools';
import { hasPricesEditPermission } from '@paragon/login-tools';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { importHangerPrices } from '../../actions/hangerPriceActions';
import { importLumberPrices } from '../../actions/lumberPriceActions';
import { importPlatePrices } from '../../actions/platePriceActions';
import { useAppDispatch, useAppSelector } from '../hooks';

export default function ImportButton() {
  const dispatch = useAppDispatch();
  const hasEditPermission = useAppSelector(hasPricesEditPermission);

  const activePriceGrid = useAppSelector((state) => state.view.activePriceGrid);

  const onFilesLoading = (file: ReadFile) => {
    switch (activePriceGrid) {
      case 'Lumber':
        return dispatch(importLumberPrices(file));
      case 'Plates':
        return dispatch(importPlatePrices(file));
      case 'Hangers':
        return dispatch(importHangerPrices(file));
      default:
        assertExhaustiveSwitch(activePriceGrid);
    }
  };

  const isLumber = activePriceGrid === 'Lumber';
  const [renderFileSelect, selectFile] = useHiddenFileSelect(isLumber ? '.xls,.xlsx,.csv' : '.csv', false);

  return (
    <>
      <Button
        variant="contained"
        sx={{ m: 1 }}
        onClick={() => selectFile().then(onFilesLoading)}
        disabled={!hasEditPermission}
      >
        Import
      </Button>
      {renderFileSelect()}
    </>
  );
}
